import actions from './actionTypes';

const initialState = {
  project: {},
  backupProject: null,
  showLoaderOnAddToOredr: true,
  template_details: [],
  multiWallProjects: [],
  activeMultiWallProjectIndex: 0,
  leftWallPreviews: [],
  rightWallPreviews: [],
  rightPreviewInProgress: false,
  leftPreviewInProgress: false,
  orderFormData: {
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    country: '',
    state: '',
    zipCode: '',
    phoneNumber: '',
    companyName: '',
    postalAddress: '',
    invoiceFile: null,
    serialNumber: null,
    extraInfo: null,
    sendInstallationInstruction: false,
    termsAndConditionState: true,
    personalInformationCondition: false,
    serviceProviderCondition: true
  }
};

export default function finalCheckReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_PROJECT_STRUCTURE:
      return {
        ...state,
        project: action.payload.project
      };
    case actions.BACKUP_ACTIVE_PROJECT:
      return {
        ...state,
        backupProject: action.payload.backupProject
      };
    case actions.LOADER_ON_ADD_TO_ORDER:
      return {
        ...state,
        showLoaderOnAddToOredr: false
      };
    case actions.SET_MULTIWALL_PROJECTS:
      return {
        ...state,
        multiWallProjects: [...action.payload.multiWallProjects]
      };
    case actions.SET_ACTIVE_MULTIWALL_PROJECT_INDEX:
      return {
        ...state,
        activeMultiWallProjectIndex: action.payload.activeMultiWallProjectIndex
      };
    case actions.SET_LEFT_WALL_PREVIEWS:
      return {
        ...state,
        leftWallPreviews: action.payload.leftWallPreviews
      };
    case actions.SET_RIGHT_WALL_PREVIEWS:
      return {
        ...state,
        rightWallPreviews: action.payload.rightWallPreviews
      };
    case actions.SET_RIGHT_PREVIEW_IN_PROGESS:
      return {
        ...state,
        rightPreviewInProgress: action.payload.inProgress
      };
    case actions.SET_LEFT_PREVIEW_IN_PROGESS:
      return {
        ...state,
        leftPreviewInProgress: action.payload.inProgress
      };

    case actions.SET_ORDER_FORM_DETAILS:
      return {
        ...state,
        orderFormData: {
          ...state.orderFormData,
          firstName: action.payload.formData.firstName,
          lastName: action.payload.formData.lastName,
          address: action.payload.formData.address,
          city: action.payload.formData.city,
          country: action.payload.formData.country,
          state: action.payload.formData.state,
          zipCode: action.payload.formData.zipCode,
          phoneNumber: action.payload.formData.phoneNumber,
          companyName: action.payload.formData.companyName,
          postalAddress: action.payload.formData.postalAddress,
          invoiceFile: action.payload.formData.invoiceFile,
          serialNumber: action.payload.formData.serialNumber,
          extraInfo: action.payload.formData.extraInfo,
          sendInstallationInstruction:
            action.payload.formData.sendInstallationInstruction,
          termsAndConditionState:
            action.payload.formData.termsAndConditionState,
          personalInformationCondition:
            action.payload.formData.personalInformationCondition,
          serviceProviderCondition:
            action.payload.formData.serviceProviderCondition
        }
      };
    default:
      return state;
  }
}
